export const favoritesTabTabs = [
  { title: 'favorites.won', key: 'WON' },
  // { title: 'favorites.recentlyFinished', key: 'RECENTLY_FINISHED' },
];

export const favoritesStatusTabs = [
  { title: 'myTenders.active', key: ['OPEN_FOR_BID', 'PUBLISHED'] },
  {
    title: 'myTenders.forApprove',
    key: ['ON_APPROVAL', 'ON_APPROVAL_UNSUCCESSFUL'],
  },
  { title: 'myTenders.all', key: [] },
];
